import { parse, unparse } from 'papaparse';
import { tsvOptions } from './ClickMapPoll';
import type { ImageClick } from './types';

export async function replaceUnsafeClickMap(text: string, replaceUnsafeInput: (test: string) => Promise<string>) {
  if (typeof text !== 'string') return text;
  const clicks = parse<ImageClick>(text, tsvOptions).data;
  for (const click of clicks) {
    if (click.comment) click.comment = await replaceUnsafeInput(click.comment);
  }
  return unparse(clicks, tsvOptions);
}
